export default
    {
        // url: this.$store.state.http.gld.YYYY,
        gldSubeArchivo: "/calidadResumen/gldSubeArchivo",
        listSatisfaccion: "/calidadResumen/gldListSatisf",
    }
